/*
*
 * */
import router from '@/router'
import utils from '@/utils'

const defaultCode = 'inesa'
router.beforeEach((to, from, next) => {
  var _to = function () {
    if (!to.query.domain) {
      to.query.domain = d;
      if (h) { to.query.h = h; }
      if (e) { to.query.expired = e; }
      next({
        path: to.path,
        query: to.query
      });
    } else {
      next();
    }
  }
  var d = utils.getQueryString('domain')
  // var d = to.query.domain  // 前往路由的domain（改变后的domain）
  // var oldd = from.query.domain // 改变前的domain
  var h = utils.getQueryString('h') // 登录前的页面保存住，登陆后调回
  var e = utils.getQueryString('expired') // 处理过期的情况
  if (!d) {
    d = defaultCode
  }
  _to()
})



// WEBPACK FOOTER //
// ./src/router/beforeRedirect.js